/**
 * Renders sourcing-link resume upload failure activity.
 *
 * <p>Pass the ATS reason to the shared activity-log layout.
 */
import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment;
}

const ActivityLogTaskSourcingLinkResumeUpload: FCWithFragments<Fragments> = ({ activityLog }) => {
  const reason =
    activityLog.details?.__typename === 'ActivityLogTaskSourcingLinkResumeUploadDetails'
      ? activityLog.details.reason
      : '';

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabel={`could not upload the resume to the ATS: ${reason}`}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.sourcingLinkResumeUploadFailed"
      actionLabelValues={{ reason }}
    />
  );
};

ActivityLogTaskSourcingLinkResumeUpload.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}

    fragment ActivityLogTaskSourcingLinkResumeUpload_activityLog on ActivityLog {
      id
      activityType
      details {
        ... on ActivityLogTaskSourcingLinkResumeUploadDetails {
          __typename
          reason
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskSourcingLinkResumeUpload;
